
import {
  Component,
  Vue,
  Inject,
  Prop,
  Watch,
  Ref
} from "vue-property-decorator";
import { ElForm } from "element-ui/types/form";
import api from "@/api";
import BatchUpload from "@/components/BatchUpload/index.vue";
import {AttachmentHostType, ProtocolCreateUpdateInput} from "@/api/appService";

@Component({components:{
  BatchUpload
  }})
export default class EditProtocol extends Vue {
  @Ref() readonly dataForm!: ElForm;
  @Prop() type!: any;

  get dialogTitle() {
    return this.form!.id ? "编辑" : "新建";
  }

  get hostType(){
    return AttachmentHostType.Protocol;
  }

  defaultData: any = {
    /**协议编号 */
    serialNumber: undefined,
    /** 协议名称 */
    displayName: undefined,
    /** 合作周期(年) */
    cooperationPeriod: undefined,
    /** 签订时间 */
    signingDate: undefined,
    /** 备注 */
    remark: undefined,
    savedAttachments: [],
    attachments: [],
    id: 0,
    type: 0
  };

  show = false;
  form: any = { ...this.defaultData };

  async save() {
    this.form.type = this.type;

    this.dataForm.validate(async (valid: boolean) => {
      if (valid) {
        if (this.form!.id) {
          await api.protocol.update({ body: this.form });
        } else {
          await api.protocol.create({ body: this.form });
        }
        this.show = false;
        this.$message.success("更新成功");
        this.$emit("onSave");
      }
    });
  }


  cancel() {
    this.show = false;
    this.form = { ...this.defaultData };
  }

  roleRule = {
    serialNumber: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      }
    ],
    displayName: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      }
    ],
    cooperationPeriod: [
      {
        required: true,
        message: "必填",
        trigger: "blur"
      }
    ],
    signingDate: [
      {
        required: true,
        message: "必须",
        trigger: "blur"
      }
    ]
  };
}
